/**
 * Quick-add bottom sheet (móvil) — Apodemia
 *
 * El "+" de las cards ([data-quick-sheet-trigger], solo móvil) abre un sheet
 * inferior global: carga el producto por AJAX (/products/<handle>.js), pinta
 * las opciones como pills (funciona con 1, 2 o 3 opciones), resuelve la
 * variante al vuelo y añade via /cart/add → dispara `cart:updated` (el
 * sidecart se refresca y se abre solo, igual que el quick-add de escritorio).
 */
(function () {
  'use strict';

  var sheet = document.querySelector('[data-quick-sheet]');
  if (!sheet) return;

  var panel = sheet.querySelector('[data-qsheet-panel]');
  var body = sheet.querySelector('[data-qsheet-body]');
  var T = {
    add: sheet.getAttribute('data-t-add') || 'Añadir al carrito',
    soldout: sheet.getAttribute('data-t-soldout') || 'Agotado',
    size: sheet.getAttribute('data-t-size') || 'Talla'
  };
  var addUrl = sheet.getAttribute('data-cart-add-url') || '/cart/add';

  // ---- Body scroll lock (mismo patrón que shop-the-look: iOS ignora
  // overflow:hidden en el body) ------------------------------------------
  var lockY = 0;
  var lockBody = function () {
    lockY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -lockY + 'px';
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  };
  var unlockBody = function () {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.left = '';
    document.body.style.right = '';
    document.body.style.width = '';
    window.scrollTo(0, lockY);
  };

  // ---- Dinero: mismo formato que el resto del tema ----------------------
  var money = function (cents) {
    var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
    var lang = document.documentElement.lang || 'es';
    try {
      return new Intl.NumberFormat(lang, { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' €';
    }
  };

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  };

  // ---- Apertura / cierre -------------------------------------------------
  var open = function () {
    sheet.hidden = false;
    lockBody();
    // Oculta el sticky ATC de las PDP mientras el sheet esta abierto (lo tapaba).
    document.documentElement.classList.add('qsheet-open');
    requestAnimationFrame(function () {
      sheet.classList.add('is-open');
      panel.focus({ preventScroll: true });
    });
  };
  var close = function () {
    sheet.classList.remove('is-open');
    unlockBody();
    document.documentElement.classList.remove('qsheet-open');
    setTimeout(function () { sheet.hidden = true; body.innerHTML = ''; }, 350);
  };

  sheet.addEventListener('click', function (e) {
    if (e.target.closest('[data-qsheet-close]')) close();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });

  // ---- Render ------------------------------------------------------------
  var product = null;
  var selected = []; // valor elegido por posición de opción

  var findVariant = function () {
    if (!product) return null;
    for (var i = 0; i < product.variants.length; i++) {
      var v = product.variants[i];
      var okAll = true;
      for (var j = 0; j < selected.length; j++) {
        var opt = v['option' + (j + 1)];
        if (opt !== selected[j]) { okAll = false; break; }
      }
      if (okAll) return v;
    }
    return null;
  };

  var refresh = function () {
    var v = findVariant();
    var priceEl = body.querySelector('[data-qsheet-price]');
    var wasEl = body.querySelector('[data-qsheet-was]');
    var btn = body.querySelector('[data-qsheet-add]');
    if (v && priceEl) {
      priceEl.textContent = money(v.price);
      if (wasEl) {
        var hasWas = v.compare_at_price && v.compare_at_price > v.price;
        wasEl.hidden = !hasWas;
        wasEl.textContent = hasWas ? money(v.compare_at_price) : '';
      }
    }
    if (btn) {
      var ok = v && v.available;
      btn.disabled = !ok;
      btn.textContent = ok ? T.add : T.soldout;
      btn.setAttribute('data-variant-id', v ? v.id : '');
    }
    // Estado visual de las pills
    body.querySelectorAll('[data-qsheet-pill]').forEach(function (p) {
      var pos = parseInt(p.getAttribute('data-opt-pos'), 10);
      p.classList.toggle('is-selected', selected[pos] === p.getAttribute('data-opt-value'));
    });
  };

  // product.js puede devolver options como strings o como objetos
  // {name, position, values} segun tienda/version: se normaliza a string.
  var optionName = function (opt) {
    if (typeof opt === 'string') return opt;
    return (opt && opt.name) || '';
  };

  var optionLabel = function (opt) {
    var name = optionName(opt);
    // Los datos de admin traen a veces "Option1"/"Title" como nombre real.
    if (/^(option ?\d|title|size)$/i.test(name)) return T.size;
    return name;
  };

  var render = function () {
    var v0 = null;
    for (var i = 0; i < product.variants.length; i++) {
      if (product.variants[i].available) { v0 = product.variants[i]; break; }
    }
    v0 = v0 || product.variants[0];
    selected = [v0.option1, v0.option2, v0.option3].slice(0, product.options.length);

    var html = '';
    html += '<div class="iurop-qsheet__head">';
    if (product.featured_image) {
      var imgSep = product.featured_image.indexOf('?') > -1 ? '&' : '?';
      html += '<img class="iurop-qsheet__img" src="' + esc(product.featured_image + imgSep + 'width=180') + '" width="72" height="90" alt="" loading="eager">';
    }
    html += '<div class="iurop-qsheet__meta">';
    html += '<p class="iurop-qsheet__title">' + esc(product.title) + '</p>';
    html += '<p class="iurop-qsheet__price"><s class="iurop-qsheet__was" data-qsheet-was hidden></s> <span data-qsheet-price></span></p>';
    html += '</div></div>';

    var singleDefault = product.variants.length === 1 && product.options.length === 1 && /default title/i.test(product.variants[0].title || '');
    if (!singleDefault) {
      product.options.forEach(function (opt, pos) {
        // Valores únicos por posición, en orden de aparición.
        var values = [];
        product.variants.forEach(function (v) {
          var val = v['option' + (pos + 1)];
          if (val != null && values.indexOf(val) === -1) values.push(val);
        });
        if (values.length < 2 && product.options.length === 1) return;
        html += '<div class="iurop-qsheet__group">';
        html += '<span class="iurop-qsheet__group-label">' + esc(optionLabel(opt)) + '</span>';
        html += '<div class="iurop-qsheet__pills">';
        values.forEach(function (val) {
          // En productos de 1 opción se puede saber la disponibilidad por pill.
          var disabled = '';
          if (product.options.length === 1) {
            var pv = null;
            for (var k = 0; k < product.variants.length; k++) {
              if (product.variants[k].option1 === val) { pv = product.variants[k]; break; }
            }
            if (pv && !pv.available) disabled = ' disabled aria-disabled="true"';
          }
          html += '<button type="button" class="iurop-qsheet__pill" data-qsheet-pill data-opt-pos="' + pos + '" data-opt-value="' + esc(val) + '"' + disabled + '>' + esc(val) + '</button>';
        });
        html += '</div></div>';
      });
    }

    html += '<button type="button" class="iurop-qsheet__add" data-qsheet-add>' + esc(T.add) + '</button>';
    body.innerHTML = html;
    refresh();
  };

  // ---- Interacción dentro del sheet ---------------------------------------
  body.addEventListener('click', function (e) {
    var pill = e.target.closest('[data-qsheet-pill]');
    if (pill && !pill.disabled) {
      selected[parseInt(pill.getAttribute('data-opt-pos'), 10)] = pill.getAttribute('data-opt-value');
      refresh();
      return;
    }
    var btn = e.target.closest('[data-qsheet-add]');
    if (btn && !btn.disabled) {
      var vid = btn.getAttribute('data-variant-id');
      if (!vid) return;
      btn.disabled = true;
      btn.classList.add('is-loading');
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('add failed');
          return r.json();
        })
        .then(function () {
          close();
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: { source: 'quick-sheet' } }));
        })
        .catch(function (err) {
          btn.disabled = false;
          btn.classList.remove('is-loading');
          console.error('[quick-sheet] add failed', err);
        });
    }
  });

  // ---- Trigger en las cards ------------------------------------------------
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-quick-sheet-trigger]');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    var url = trigger.getAttribute('data-product-url');
    if (!url) return;
    product = null;
    body.innerHTML = '<div class="iurop-qsheet__spinner" aria-hidden="true"></div>';
    open();
    // .js sobre la URL del producto (respeta locale y /collections/../products/..)
    var jsUrl = url.split('?')[0] + '.js';
    fetch(jsUrl, { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('product fetch failed');
        return r.json();
      })
      .then(function (p) {
        product = p;
        render();
      })
      .catch(function (err) {
        console.error('[quick-sheet] product fetch failed', err);
        // Fallback honesto: a la PDP.
        window.location.href = url;
      });
  });
})();
